const notamType = [
  { label: 'New', value: 'N' },
  { label: 'Replaced', value: 'R' },
  { label: 'Canceled', value: 'C' },
]

export default notamType
